import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { toFixed } from 'accounting';

// Based in part on https://g14n.info/2019/09/react-input-number/
function NumberInput(props) {
  const { name, value, precision, onChange, readOnly } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  // Display value accounts for decimal precision, blanks, and edits.
  const preciseValue = precision ? toFixed(value, precision) : value;
  const maybeValue = typeof preciseValue === 'undefined' ? '' : preciseValue;
  const displayValue = isEditing ? currentValue : maybeValue;

  return (
    <FormControl
      type="string"
      name={name}
      value={displayValue}
      onChange={e => {
        // Only allow decimal separator and numbers.
        let maybeNumber = e.target.value;
        maybeNumber = maybeNumber.replace(/[^.\d]/, '');
        setCurrentValue(maybeNumber);
      }}
      readOnly={readOnly}
      onFocus={() => {
        if (readOnly) return;
        if (precision) {
          setCurrentValue(toFixed(displayValue, precision));
        } else if (typeof value === 'number') {
          setCurrentValue(String(value));
        } else {
          setCurrentValue('');
        }
        setIsEditing(true);
      }}
      onBlur={() => {
        if (readOnly) return;
        setIsEditing(false);
        onChange(currentValue);
      }}
    />
  );
}

NumberInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  precision: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default NumberInput;
